import { AnyExtension } from "@tiptap/react";
import CustomKeymap from "./custom-keymap";
import { UiState } from "./ui-state-extension";
import { SourceCitation } from "./source-citation";
// import CollaborationCommentsExtension from "./commenting";
export const CustomExtensions: AnyExtension[] = [
  CustomKeymap,
  // CollaborationCommentsExtension, // Disabled Y.js comments in favor of REST-based comments
  UiState,
  SourceCitation,
];
